
import React from "react";
import { PhoneFilled, MailFilled, ClockCircleFilled, FacebookFilled, TwitterCircleFilled, InstagramFilled } from "@ant-design/icons";

const TopBar = () => {
  return (
    <div className="bg-pink-600 text-white py-6 px-8 flex flex-col md:flex-row justify-between items-center text-sm relative overflow-hidden">
      {/* Sliding Container */}
      <div className="absolute inset-0 flex items-center animate-slide">
        <div className="flex space-x-5 whitespace-nowrap">
          <div className="flex items-center space-x-2 mr-5">
            <PhoneFilled className="text-lg" />
            <span className="text-[22px]">+91 7761876100</span>
          </div>
          <div className="flex items-center space-x-2 mr-5">
            <MailFilled className="text-lg" />
            {/* <span>info@example.com</span> */}
          </div>
          <div className="flex items-center space-x-2 mr-5">
            <ClockCircleFilled className="text-lg" />
            <span className="text-[22px]">Opening: 8:00 AM - 8:00 PM</span>
          </div>
          <div className="flex items-center space-x-2">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-lg mr-3">
              <FacebookFilled />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-lg mr-3">
              <TwitterCircleFilled />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-lg">
              <InstagramFilled />
            </a>
          </div>
          <div className="relative z-10 flex items-center space-x-2 text-sm">
        <span className="text-[22px]">Note: FUTURE SKILL Computer Training Institute is a leading educational center dedicated to providing top-tier computer education and training. Our institute offers a wide range of courses in software development, programming languages, web design, networking, data science, cybersecurity, and more. With experienced instructors, state-of-the-art labs, and a hands-on learning approach, we aim to equip students with the practical skills needed to excel in the fast-evolving tech industry. Whether you're a beginner or an advanced learner, our comprehensive curriculum and personalized support ensure that every student is prepared for success in their chosen field. Join us to unlock your potential and stay ahead in the world of technology!</span>
      </div>
        </div>
      </div>
      
    </div>
  );
};

export default TopBar;


